module.exports = __webpack_public_path__ + "img/house-white.b843dac3.png";